//
// locales/vanilla/ur.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/ur.json';
import localeData from 'react-intl/locale-data/ur.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
